import { render } from "./verifyTransactionWithoutAuthentication.vue?vue&type=template&id=1287b498"
import script from "./verifyTransactionWithoutAuthentication.vue?vue&type=script&lang=js"
export * from "./verifyTransactionWithoutAuthentication.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/khatoncollection-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__